import { ICON_TYPES } from '../constants';

export const MultipurposeSportsCourt = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.375 2.625H2.625C1.17775 2.625 0 3.80275 0 5.25V18.375H1.52863L4.47213 15.4271L7.49788 18.452L10.5306 15.4192L13.5634 18.452L16.5944 15.421L19.5466 18.3741H21V5.25C21 3.80275 19.8223 2.625 18.375 2.625ZM3.22787 8.11738L1.75 9.59525V6.6395L3.22787 8.11738ZM4.46513 9.35462L6.26587 11.1554L4.47125 12.9517L2.66963 11.1501L4.46513 9.35462ZM5.70238 8.11738L7.49788 6.32275L9.296 8.12175L7.50225 9.91725L5.70238 8.11738ZM9.44475 4.375H11.6156L12.327 5.08638L10.5324 6.88363L8.73512 5.0855L9.44563 4.37587L9.44475 4.375ZM10.5332 9.359L12.3253 11.151L10.5306 12.9456L8.7395 11.1545L10.5332 9.359ZM11.7696 8.12088L13.5651 6.32363L15.3589 8.11738L13.5625 9.91375L11.7696 8.12088ZM16.5961 9.35462L18.3916 11.1501L16.5952 12.9465L14.7997 11.151L16.5961 9.35462ZM17.8334 8.11738L19.25 6.70075V9.534L17.8334 8.11738ZM18.375 4.375C18.5789 4.375 18.7661 4.445 18.9149 4.56225L16.5961 6.881L14.8015 5.08638L15.5111 4.37587H18.3741L18.375 4.375ZM5.551 4.375L6.26063 5.08462L4.46513 6.88013L2.12013 4.536C2.26275 4.43537 2.43688 4.375 2.625 4.375H5.551ZM1.75 15.6765V12.705L3.23487 14.1899L1.75 15.6765ZM7.49788 15.9784L5.7085 14.1899L7.50312 12.3935L9.29338 14.1837L7.49788 15.9784ZM13.5634 15.9784L11.7679 14.1829L13.5616 12.3891L15.3562 14.1846L13.5625 15.9784H13.5634ZM17.8316 14.1846L19.25 12.7663V15.603L17.8316 14.1846Z"
        fill="#43494F"
      />
    </svg>
  );
};

MultipurposeSportsCourt.iconType = ICON_TYPES.MULTI_SPORTS_COURT;
